<script>
import router from "@/router";
import {mapGetters} from "vuex";

export default {
  name: "ProductsWrapper",
  props: {
    slicer: {
      default: Infinity,
    },
    productCategories: {
      default: null,
      validator(value) {
        // The value must match one of these strings
        return typeof value == "object"
      }
    },
    productBrands: {
      default: null,
      validator(value) {
        // The value must match one of these strings
        return typeof value == "object"
      }
    },
    digital: {
      default: '',
      validator(value) {
        // The value must match one of these strings
        return ['', '0', '1'].includes(value.toString())
      }
    },
    sort: {
      default: '',
      validator(value) {
        // The value must match one of these strings
        return ['', 'asc', 'desc'].includes(value)
      }
    },
    price: {
      default: null,
    },
    search: {
      default: null,
    },
    pauseIfCategoryNotFound: {
      default: true,
    },
    pauseIfBrandNotFound: {
      default: true,
    },
    setQueryOnRouterAfterEachRequest: {
      default: false
    },
    setQueryFromRouter: {
      default: false
    },
    dirtyRouterAfterPageChange: {
      default: true,
    }
  },
  data() {
    return {
      current_page: 1,
      products: [],
      categories: [],
      brands: [],
      paginationMeta: [],
    }
  },
  computed: {
    ...mapGetters({
      filters: 'Product/getFilters'
    })
  },
  methods: {
    async changePage(page) {

      await this.setProducts(page)

      this.current_page = page

      if (this.dirtyRouterAfterPageChange) {
        this.dirtyRouter()
      }

      this.$emit("current_page", page);
    },
    async setProducts(page = 1) {

      if (this.digital !== '') {
        this.$store.commit("Product/setFilters", {key: "is_digital", value: this.digital});
      }

      if (this.sort !== '') {
        this.$store.commit("Product/setFilters", {key: "sort", value: this.sort})
      }

      if (this.search !== null) {
        this.$store.commit("Product/setFilters", {key: "search", value: this.search})
      }

      if (this.productBrands !== null) {
        this.$store.commit("Product/setFilters", {key: "brand", value: this.brands});
      }

      if (this.productCategories !== null) {
        this.$store.commit("Product/setFilters", {key: "category", value: this.categories});
      }

      if (this.price) {
        const price = this.price.split('-')
        const priceValues = {minValue: price[0], maxValue: price[1]}
        this.$store.commit("Product/setFilters", {
          key: "price",
          value: priceValues,
        });
      }

      if (this.pauseIfCategoryNotFound && this.productCategories != null && this.categories.length === 0) {
        return true;
      }

      if (this.pauseIfBrandNotFound && this.productBrands != null && this.brands.length === 0) {
        return true;
      }

      if (this.setQueryOnRouterAfterEachRequest) {
        this.dirtyRouter()
      }

      const response = await this.$store.dispatch('Product/setProductsWithoutState', page)
      let data = response.data.data

      this.products = data.data
      this.paginationMeta = data.meta

      this.$emit("products", this.products);
    },
    async setBrands() {
      let form = {brands: this.productBrands}
      const brands = await this.$store.dispatch('Brand/getBrandsWithSlug', form)

      this.brands = await brands.data.data.map(item => {
        return item.id
      });

      this.$emit("brand", this.brands);
    },
    async setCategories() {
      let form = {categories: this.productCategories}
      const categories = await this.$store.dispatch('Category/getCategoryWithSlug', form)

      this.categories = await categories.data.data.map(item => {
        return item.id
      });

      this.$emit("categories", this.categories);

    },
    setRouterQuery(filters) {

      let result = {}

      Object.entries(filters).forEach(([key, value]) => {
        if (key === 'price' && value.minValue !== null && value.maxValue !== null) {
          result[key] = `${value.minValue}-${value.maxValue}`
        }
        if (key !== 'price') {
          result[key] = typeof value == 'object' ? value.join(',') : value
        }
      });
      return result

    },
    setFilterFromRouterQuery() {
      const routerQuery = this.$route.query;

      let result = {}

      Object.entries(this.filters).forEach(([key, value]) => {
        if (key === 'price' && value.minValue !== null && value.maxValue !== null) {
          let value = routerQuery[key].split('-')
          result[key]['minValue'] = value[0]
          result[key]['maxValue'] = value[1]
          this.$store.commit("Product/setFilters", {key: key, value: {minValue: value[0], maxValue: value[1]}})
        }
        if (key !== 'price') {
          let value = routerQuery[key];
          result[key] = (['brand', 'category'].indexOf(key) > -1) ? value.split(',') : value
          this.$store.commit("Product/setFilters", {key: key, value: result[key]})

        }
      });
      return result

    },
    dirtyRouter() {

      const filters = this.setRouterQuery(this.filters);
      router.push({name: 'Products', query: {...filters, page: this.current_page}})

    }
  },
  render() {
    return this.$scopedSlots.default({
      products: this.products.slice(0, this.slicer),
      pagination: this.paginationMeta,
      changePageFunction: this.changePage,
      current_page: this.current_page,
    });
  },
  async mounted() {

    if (this.productBrands !== null) {
      await this.setBrands()
    }

    if (this.productCategories !== null) {
      await this.setCategories()
    }

    if (this.setQueryFromRouter) {
      this.setFilterFromRouterQuery()
    }

    await this.setProducts()

  },
}
</script>
